import { createSelector, createStateHook } from 'react-sweet-state';
import { store } from '../../main';
var stableEmpty = {};
var stableEmptyScreenTabsArrray = [];
var selectCurrentFormState = createSelector(function (state) {
  return state.formData;
}, function (state) {
  return state.screenTabs;
}, function (formData, screenTabs) {
  if (formData !== null) {
    return {
      currentFormState: formData,
      currentScreenTabsState: screenTabs || stableEmptyScreenTabsArrray
    };
  }
  return {
    currentFormState: stableEmpty,
    currentScreenTabsState: stableEmptyScreenTabsArrray
  };
});
export var useCurrentFormState = createStateHook(store, {
  selector: selectCurrentFormState
});